export const TranslationsHU = {
    // languages
    languages: {
        en: 'angol',
        ar: 'عربى',
        bg: 'Bulgária',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'USZONY',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'FEJ',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VERSENG',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'Rendeljen online',
        cart: 'Kosár',
        open_24: '24 óra',
        closed: 'Zárt',
        free: 'INGYENES',
        something_went_wrong: 'valami elromlott',
        try_again: 'próbáld újra',
    },
    constants: {
        calendar: {
            days: {
                monday: 'hétfő',
                tuesday: 'kedd',
                wednesday: 'szerda',
                thursday: 'csütörtök',
                friday: 'péntek',
                saturday: 'szombat',
                sunday: 'vasárnap',
            },
        },
        services: {
            pickup: 'Felvétel',
            delivery: 'Szállítás',
            dine_in: 'Helyben fogyasztás',
            table_booking: 'Asztalfoglalás',
        },
        payment: {
            method: {
                cash: 'Készpénz',
                card: 'Kártya',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Készpénz',
                card: 'Kártya',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Siker',
                pending: 'Függőben levő',
                error: 'Hiba',
                refunded: 'Visszatérítve',
                refunding: 'Visszatérítés',
                partial_refunded: 'Részben visszafizetve',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Távolítsa el',
                drop_here: 'Dobja ide a fájljait, vagy kattintson a kiválasztáshoz',
                accepts: '{{fileTypes}} fájlt fogad el',
                errors: {
                    max_files: 'Maximum {{number}} megengedett',
                    max_size: 'Maximális fájlméret {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'A bolt jelenleg zárva van, és egy étkezési rendelés nem helyezhető el azonnal. Próbáljon meg egy későbbi dátumot és időt választani',
            },
            buttons: {
                order: {
                    book_order: 'Foglaljon asztalt / Rendeljen online',
                    order_online: 'Rendeljen online',
                    book_table: 'Foglaljon asztalt',
                    order: 'Rendelés',
                    book: 'Könyv',
                    cart: 'Kosár',
                    restart: 'Indítsa újra',
                    closed: 'Üzlet zárva',
                    not_accepting: 'Megrendeléseket nem fogad el',
                },
            },
        },
        modals: {
            auth: {
                login: 'Bejelentkezés',
                register: 'Nyilvántartás',
                register_commence: 'Folytatás',
                register_complete: 'Fiók létrehozása',
                register_confirmation_sent: 'A megerősítő kódot elküldtük az e-mail címére. Kérjük, írja be a következő mezőbe a folytatáshoz',
                register_confirmation_resent: 'A megerősítő kódot újra elküldtük, ellenőrizze a spam mappáját, vagy indítsa újra a folyamatot',
                register_restart: 'Indítsa újra',
                register_resend_code: 'Kód újraküldése',
                register_confirmation_code_subject: 'E-mail megerősítő kód',
                register_confirmation_code_email: 'Az e-mail megerősítő kódja: {{confirmation_code}} (24 órán belül lejár)',
                login_placeholder: 'Email',
                password_placeholder: 'Jelszó',
                confirm_password_placeholder: 'Jelszó megerősítése',
                confirmation_code_placeholder: 'E-mail megerősítő kód',
                accept_terms: 'Fogadja el az Általános Szerződési Feltételeket',
                accept_terms_view: 'Kilátás',
                login_facebook: 'Bejelentkezés Facebookkal',
                login_google: 'Bejelentkezés Google-lel',
                benefits: 'Jelentkezzen be vagy hozzon létre egy fiókot az összes rendelés mentéséhez',
                logged_in: 'Sikeres bejelentkezés',
                logged_out: 'Kijelentkezett',
                password_reset: {
                    init_button: 'Jelszó-visszaállítási levél küldése',
                    init_success: 'A jelszó-visszaállítási linket elküldtük az e-mail címére',
                    complete_button: 'Jelszó visszaállítása',
                    complete_success: 'A jelszó sikeresen visszaállítása, jelentkezzen be új jelszavával',
                    forgot_password_text: 'Elfelejtette jelszavát?',
                    forgot_password_link: 'Jelszó visszaállítása',
                    remember_password_text: 'Emlékszel a jelszavadra?',
                    remember_password_link: 'Menj vissza',
                    invalid_title: 'A jelszó visszaállítása érvénytelen',
                    invalid_description: 'Ez a jelszó-visszaállítási hivatkozás érvénytelen, kérjen helyette újat',
                    invalid_link: 'Ugrás a Bejelentkezéshez',
                    title: 'Jelszó visszaállítása',
                    description: 'Adjon meg új jelszót a fiókjához',
                },
                error_generic: 'Hiba történt. Kérjük, próbálja újra, vagy lépjen kapcsolatba velünk',
                error_accept_terms: 'Kérjük, fogadja el a feltételeket',
                error_password_length: 'A jelszó minimum 6 karakter',
                error_social: 'Hiba történt, próbálja újra, vagy lépjen kapcsolatba velünk',
                error_confirmation_code: 'Érvénytelen megerősítő kód',
                error_invalid_code: 'Érvénytelen megerősítő kód',
                error_exists: 'A felhasználó már létezik',
                error_invalid_email_pass: 'Érvénytelen e-mail cím vagy jelszó',
                error_password_no_match: 'A jelszavak nem egyeznek egymással',
                error_user_not_found: 'Nincs felhasználó ezzel az e-mail címmel',
                error_invalid_email: 'Érvénytelen e-mail cím',
                error_invalid_reset_token: 'Érvénytelen visszaállítási hivatkozás, kérjen másikat',
            },
            booking: {
                form: {
                    name: 'Teljes név',
                    email: 'E-mail cím',
                    phone: 'Telefonszám',
                    number_of_people: 'Emberek száma',
                    number_of_people_max: 'Emberek száma ({{max_people}} max.)',
                    number_of_people_min: 'Emberek száma ({{min_people}} Min.)',
                    number_of_people_max_min: 'Emberek száma ({{min_people}} és {{max_people}} között)',
                    notes: 'Megjegyzések / Különleges kérések',
                    submit: 'Foglalási kérelem benyújtása',
                    email_optional: '(nem kötelező)',
                    date: 'Dátum',
                    duration: 'Időtartam',
                    seating: 'Elérhető időpontok',
                    number_of_guests: 'Vendégek száma',
                    notes_placeholder: 'Allergiák, alkalom, ülőhely-preferencia',
                    reserving: 'Foglalás...',
                    reserve_table: 'Asztal foglalása',
                    please_choose_a_date_and_time: 'Válasszon dátumot és időpontot.',
                    invalid_people: 'A létszámnak {{min}} és {{max}} között kell lennie.',
                    party_size_max_fallback: 'a megengedett maximum',
                    loading_available_times: 'Elérhető időpontok betöltése…',
                    select_a_date_to_see_available_times: 'Válasszon dátumot az elérhető időpontok megtekintéséhez.',
                    no_times_available_for_this_date: 'Erre a napra nincs elérhető időpont. Válasszon másik napot.',
                    shift: 'Műszak',
                    service_times: 'Nyitvatartás',
                    new_shift: 'Új műszak',
                    time: 'időpont',
                    times: 'időpont',
                    unavailable: 'Nem elérhető',
                    available: 'Elérhető',
                    required_name: 'Adja meg a nevét.',
                    required_phone: 'Adja meg a telefonszámát.',
                    required_email: 'Adja meg az e-mail-címét.',
                    invalid_email: 'Adjon meg érvényes e-mail-címet.',
                    required_terms: 'A foglalás előtt fogadja el a feltételeket.',
                    reservation_is_unavailable: 'A foglalás nem érhető el.',
                    please_contact_the_restaurant_directly: 'Lépjen kapcsolatba közvetlenül az étteremmel.',
                    almost_done: 'Majdnem kész',
                    your_details: 'Az Ön adatai',
                    tell_us_who_s_coming: 'Mondja el, ki érkezik, hogy megerősíthessük a foglalását.',
                    book_your_table: 'Foglalja le az asztalát',
                    choose_a_time_that_works_for_you: 'Válasszon Önnek megfelelő időpontot.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Küldje el foglalási kérelmét, a többit az étterem intézi.',
                    select_date: 'Dátum kiválasztása',
                    standard: 'Normál',
                    minutes: 'perc',
                    next: 'Tovább →',
                    back: '← Vissza',
                    accept_terms: 'Elfogadom a feltételeket.',
                    info_1: 'Foglalásod elfogadásáról vagy elutasításáról e-mailben értesítünk',
                },
                errors: {
                    not_found: "A foglalás nem létezik. Lehetséges, hogy törölték",
                    generic: 'Hiba történt, frissítse az oldalt, vagy lépjen kapcsolatba velünk',
                    something_went_wrong: 'Valami elromlott',
                    accept_terms: 'Kérjük, fogadja el a feltételeket',
                    required_phone: 'Kérjük, adja meg telefonszámát',
                    required_email: 'Kérjük, adja meg e-mail címét',
                    required_zip: 'Kérjük, adja meg számlázási irányítószámát',
                    required_name: 'Kérjük, adja meg a nevét',
                    invalid_email: 'Kérjük, adjon meg egy érvényes e-mail címet',
                    invalid_phone: 'Kérjük, adjon meg egy érvényes telefonszámot',
                    invalid_people: 'Érvénytelen létszám',
                    missing_custom_fields: 'Kérjük, töltse ki az összes kötelező mezőt.',
                    booking_capacity_threshold: 'Erre az időpontra beteltünk. Próbáljon másik időpontot.',
                    slot_unavailable: 'Erre a létszámra beteltünk. Próbáljon másik időpontot.',
                    booking_date_paused: 'A foglalások szünetelnek erre a napra. Válasszon másik napot.',
                    invalid_table_assignment: 'Ezek az asztalok nem férnek el a társaságának. Válasszon másik időpontot.',
                    exceeded_order_limit: 'Túl sok foglalási kérelem. Próbálja újra később.',
                    validation_failed_recaptcha_v3: 'Szokatlan forgalmat észleltünk. VPN-t használ? Végezze el a fenti ellenőrzést, és próbálja újra.',
                    validation_failed_recaptcha_v2: 'A foglalást nem sikerült elindítani. Próbálja újra, vagy használjon másik módot. Ha VPN-t használ, először kapcsolja ki.',
                    booking_already_exists: 'Ez a foglalás már elküldésre került. Ellenőrizze az e-mailjét, vagy nyissa meg a foglalási linket.',
                    invalid_party_size: 'Válasszon érvényes létszámot.',
                    invalid_request: 'Érvénytelen kérés. Frissítse az oldalt, és próbálja újra.',
                    table_booking_unavailable: 'Az asztalfoglalás nem érhető el.',
                },
            },
            cart: {
                title: 'Kosár',
                proceed_to_checkout: 'Tovább a fizetéshez',
                edit_dish: 'Szerkesztés',
                remove_dish: 'Távolítsa el',
                no_items_1: 'Nincsenek tételek a kosárban',
                no_items_2: 'Először adjon hozzá néhányat a folytatáshoz',
                free_delivery_notice: 'Ingyenes házhozszállítás {{value, currency}} feletti rendelés esetén',
                errors: {
                    min_order_promo: 'A promóció alkalmazása előtt a kosár minimális értéke {{value, currency}}',
                    min_order_delivery: 'A kosár minimális értéke {{value, currency}} a szállításhoz',
                },
                promo: {
                    heading: 'Promóciós kód',
                    placeholder: 'Adja meg promóciós kódját',
                    add: 'Kód hozzáadása lehetőségre',
                    title: 'Promóció {{name}} hozzáadva a kosárhoz',
                    fixed_discount: '{{value, currency}} Ki',
                    percent_discount: '{{value}}% kedvezmény',
                    added_to_cart: 'A promóció a kosárba került',
                    errors: {
                        not_found: 'A promóció nem található',
                        disabled: 'A promóció le van tiltva',
                        not_available: 'A promóció jelenleg nem elérhető',
                        not_eligible: 'Nem jogosult promóciós kód alkalmazására',
                        not_available_time: 'Az akció erre az időre nem vonatkozik',
                        logged_in_only: 'A promóció használatához be kell jelentkezni',
                        already_used: 'Már használtad ezt a promóciót',
                        invalid: 'Ez a promóció már nem érvényes',
                        invalid_service: 'Ez a promóció nem érvényes a választott szolgáltatásra',
                        later_only: 'Csak előrendelésre érvényes',
                        now_only: 'Csak az azonnal esedékes megrendelésekre érvényes, előrendelésekre nem',
                        generic: 'Hoppá... valami hiba történt, és naplózásra került',
                        dishes_required_multi: 'Ez a promóció csak akkor érvényes, ha bizonyos termékeket hozzáad a kosarához',
                        dishes_required_single: "Ez a promóció csak akkor érvényes, ha '{{dish}}' a kosarában van",
                    },
                },
                tip: {
                    title: 'Rendelési tipp',
                    placeholder: 'Adjon hozzá egy rendelési tippet',
                },
            },
            free_items_promo: {
                title: 'Ingyenes tételek',
                usage_confirmation: {
                    question: 'Ön jogosult az ingyenes termékekre. Szeretné látni és hozzáadni őket?',
                    cancellation: "Nem, nem akarok ingyenes tételeket",
                    acceptance: 'Igen',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Válasszon ki {{number}} ingyenes terméket',
                    },
                    single: {
                        description: 'Válasszon egy ingyenes elemet',
                    },
                    confirm_button: 'Erősítse meg',
                },
            },
            checkout: {
                title: 'Pénztár',
                subtitle: 'Erősítse meg rendelési adatait',
                details: {
                    service: 'Szolgáltatás',
                    due: 'Esedékes',
                    due_now_asap: 'Most / ASAP',
                    address: 'Szállítási cím',
                    total: 'Teljes',
                    table: 'Táblázat',
                    store_location: 'Bolt címe',
                },
                customer: {
                    title: 'Vevő',
                    subtitle: 'Jelentkezzen be a rendelés és a részletek mentéséhez',
                    button: 'Bejelentkezés',
                    name: 'Teljes név',
                    email: 'E-mail-cím',
                    phone: 'Telefon',
                    phone_important: 'Telefon (fontos)',
                    notes: 'Rendelési megjegyzések',
                    delivery_notes: 'Szállítási útmutató / Rendelési megjegyzések',
                    optional: 'választható',
                },
                payment: {
                    title: 'Fizetési mód',
                    qr_modal_help: 'A {{app}} mobil alkalmazásával olvassa le a QR kódot és fejezze be a fizetést ezen a rendelésen. Miután a fizetés a mobil alkalmazásán befejeződött, lezárhatja ezt a QR modalot. Ne zárja be ezt a QR modalot, ha nem fejezte be a fizetési folyamatot.',
                    switch_to_app_help: 'A következő gombra kattintva a {{app}} mobil alkalmazás automatikusan megnyílik a fizetés befejezéséhez ezen a rendelésen. Miután a fizetés a mobil alkalmazásán befejeződött, lezárhatja ezt a modalot. Ne zárja be ezt a modalot, ha nem fejezte be a fizetési folyamatot.',
                    open_app: 'Nyissa meg a {{app}} alkalmazást',
                    continue: 'Folytatás',
                    continue_to_payment: 'Tovább ide: {{method}}',
                    back_to_cart: 'Vissza a kosárba',
                },
                accept_terms: 'Fogadja el az Általános Szerződési Feltételeket',
                accept_terms_view: 'Kilátás',
                processing_order: 'Megrendelés feldolgozása',
                warning: {
                    different_payment_currency: 'A bolt árai {{store_currency}} módon vannak megadva, de a fizetési mód {{payment_currency}} módon van megadva',
                    closing_soon: 'Hamarosan zár, a rendeléseket {{value}} percen belül kell leadni',
                    closed: 'Sajnáljuk, ez a szolgáltatás bezárt, és rendeléseket nem fogadunk el',
                    paused: 'Sajnáljuk, ez a szolgáltatás szünetel, és a rendeléseket jelenleg nem fogadjuk el',
                    expired: 'Megrendelését a választott időpontban már nem tudjuk teljesíteni. Kérjük, válasszon egy későbbi dátumot vagy időpontot',
                },
                errors: {
                    walletly_promo: 'A Walletly promóciójában hiba lépett fel. Kérjük, próbáljon ki másik promóciót!',
                    stripe_generic: 'Hitelkártyahiba, próbálkozzon újra, vagy más módszerrel',
                    validation_failed: 'Ez a fizetés jelenleg nem fogadható el. Kérjük, próbálja újra később, vagy válasszon másik fizetési módot.',
                    validation_failed_recaptcha_v3: 'Szokatlan forgalmat észleltünk. VPN-t használsz? Töltse ki a fenti kihívást, és próbálja újra.',
                    validation_failed_recaptcha_v2: 'Nem tudtuk kezdeményezni a fizetést. Kérjük, próbálja újra, vagy használjon másik módszert. Ha VPN-t használ, először kapcsolja ki.',
                    stripe_loading_fail: 'Hiba történt a fizetési űrlap betöltésekor. Kérjük, próbálja újra',
                    something_went_wrong: 'Valami elromlott',
                    paypal_generic: 'Hiba történt a PayPal szolgáltatással, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_fail: 'A fizetés sikertelen, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_cancelled: 'A fizetés törölve. Kérjük, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_error: 'Hiba történt az online fizetés feldolgozása során, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_declined: 'A fizetési módot elutasították',
                    card_declined: "A kártyád elutasítva volt, és a fizetés nem tudta feldolgozni",
                    promo_max_uses_exceeded: "Ez a promóciós kód elérte a felhasználási korlátját, és már nem érhető el.",
                    store_closed: 'Az üzlet zárva tart, rendelést már nem fogadunk',
                    accept_terms: 'Kérjük, fogadja el a feltételeket',
                    required_payment: 'Kérjük, válasszon fizetési módot',
                    required_phone: 'Kérjük, adja meg telefonszámát',
                    required_email: 'Kérjük, adja meg e-mail címét',
                    required_zip: 'Kérjük, adja meg számlázási irányítószámát',
                    required_name: 'Kérjük, adja meg a nevét',
                    invalid_email: 'Kérjük, adjon meg egy érvényes e-mail címet',
                    invalid_phone: 'Kérjük, adjon meg egy érvényes telefonszámot',
                    invalid_cc_number: 'Hitelkártya száma érvénytelen',
                    invalid_order_amount: 'Ehhez a fizetési módhoz szükséges minimális összeg',
                    retry_cc_number: 'Hiba történt, adja meg újra a hitelkártya számát, és próbálja újra',
                    closed: 'Az üzlet zárva tart, rendelést nem fogadunk',
                    promo_login_required: 'A promóció használatához be kell jelentkezni',
                    promo_used: 'Már használtad ezt a promóciót',
                    promo_by_payment_method_not_applicable: 'A promóció nem vonatkozik a kiválasztott fizetési módra.',
                    missing_custom_checkout_fields: 'Kérjük, töltse ki az összes kötelező mezőt.',
                    delivery_unavailable: 'A szállítási szolgáltatás nem érhető el ezen a pillanatban. Kérjük, fontolja meg egy Pick Up rendelést helyette.',
                    required_delivery_provider: 'Kérjük, válasszon szolgáltatás szállítást.',
                    required_delivery_quotation: 'A szállítási becslés lejárt.',
                    exceeded_order_limit: 'Jelenleg nagyon sok megrendelés érkezik hozzánk. Kérjük, válasszon egy későbbi időpontot.',
                    exceeded_order_limit_later: 'Megrendelését a választott időpontban már nem tudjuk teljesíteni. Kérjük, válasszon egy későbbi dátumot vagy időpontot',
                },
                button: {
                    continue: 'Tovább a fizetéshez',
                    place_order: 'Rendelés leadása',
                    update_order: 'Rendelés frissítése',
                },
                delivery_estimation: {
                    title: 'Szállítási becslés',
                    details: {
                        provider: 'Szállítási Szolgáltató',
                        estimated_fee: 'Becsült díj',
                        estimated_total_fee: 'Szállítási díj összesen',
                        estimated_discount_fee: 'Szállítási díj kedvezmény',
                        previous_estimated_fee: 'Előző becsült díj',
                        tips: 'Tippek',
                        estimated_delivery_time: 'Becsült szállítási idő',
                        uber_new_estimation: 'Kérjen új becslést',
                        uber_new_estimation_success: 'Új Uber-szállítási becslés alkalmazva.',
                        uber_estimation_expired: 'A szállítási becslés lejárt',
                        uber_price: 'Tartjuk az Uber árat',
                        uber_need_time: 'Több időre van szükségem',
                        lalamove_price: 'Lalamove szállítási díjat tartunk',
                        lalamove_new_estimation_success: 'Új Lalalmove szállítási becslés alkalmazva.',
                        lalamove_estimation_expired: 'A szállítási becslés lejárt',
                        lalamove_need_time: 'Több időre van szükségem',
                        lalamove_new_estimation: 'Kérjen új becslést',
                    },
                    quotation_error: 'Hiba történt a szállítási becslés kiszámításakor.',
                },
            },
            customer: {
                age_v: {
                    title: 'Életkor ellenőrzése',
                    required_for_items: 'Bizonyos termékek megrendeléséhez szükséges',
                    min_age: 'Minimális életkor: {{age}} év',
                    est_time: 'Az ellenőrzés becsült ideje: {{time}} óra',
                    upload_description: 'Töltse fel az azonosítóját a verifikációhoz. A verifikáció után e-mailben értesítünk. Töltse fel a legfeljebb 2 képet, melyeknek a maximális mérete 2 MB',
                    pending_description_1: 'Köszönjük, hogy elküldte a dokumentumait. A jóváhagyás után e-mailben értesítünk',
                    pending_description_2: 'Frissítse a lapot a verifikációs állapot frissítéséhez. Az ellenőrzés becsült ideje {{time}} óra',
                    approved_description: 'Fiókját ellenőriztük, és korlátozott menükből rendelhet',
                    rejected_description: 'A személyi igazolványát elutasították. Ha újra szeretné próbálni, kérjük, töltse fel újra az azonosítóját',
                    upload: 'Feltöltés',
                    reupload: 'Töltse fel újra a dokumentumokat',
                    go_back: 'Menj vissza',
                    view_document: 'Dokumentum megtekintése {{number}}',
                    status: {
                        unverified: 'Nem igazolt',
                        pending: 'Jóváhagyásra vár',
                        approved: 'Sikeresen ellenőrizve',
                        rejected: 'Elutasítva',
                    },
                },
                headings: {
                    sessions: 'Munkamenetek',
                    orders: 'Rendelés',
                    spend: 'Tölt',
                    order_history: 'Rendelési előzmények',
                    loyalty: 'Hűség',
                    loyalty_points: 'Hűségpontok',
                    added: 'Promó hozzáadva.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Kérjük, a beváltás előtt válasszon bármilyen terméket!',
                    not_found: 'Promóció nem található!',
                    already_exists: 'A promóció már létezik!',
                    try_again: 'Ezt az ügyletet nem lehet alkalmazni. Kérjük, próbálja újra!',
                },
            },
            custom_payment: {
                title: '{{name}} Fizetési űrlap',
                description: 'Elértél az online fizetési űrlapunkra. Kérjük, töltse ki a mezőket a fizetés elvégzéséhez. Ha egy összeget nem ad meg, akkor a részleteid elmenthetők, de nem lesznek felszámítva.',
                disabled: 'Ez az online fizetési oldal nem lett megfelelően konfigurálva. Kérjük, lépjen kapcsolatba a webhely tulajdonosával a probléma kijavításához.',
                success: 'Befizetését sikeresen feldolgoztuk, adatait elmentettük. Köszönöm',
                back: 'Vissza a Kezdőlapra',
                fields: {
                    name: 'Teljes név',
                    email: 'E-mail cím',
                    reference: 'Fizetési ref.',
                    amount: 'Összeg ($)',
                    name_on_card: 'Név a kártyán',
                    submit: 'Befizetés benyújtása',
                },
                warning: {
                    currency: 'Megjegyzés: A fizetés összege {{actual}}, nem {{default}}',
                },
                errors: {
                    generic: 'Hiba történt, próbálja újra, vagy lépjen kapcsolatba velünk',
                    stripe_generic: 'Hitelkártyahiba, frissítse az oldalt, és próbálja újra',
                    payment_fail: 'A fizetés sikertelen, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_cancelled: 'A fizetés törölve. Kérjük, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_error: 'Hiba történt az online fizetés feldolgozása során, próbálja újra, vagy válasszon másik fizetési módot',
                    payment_declined: 'A fizetési módot elutasították',
                    card_declined: "A kártyád elutasítva volt, és a fizetés nem tudta feldolgozni",
                    promo_max_uses_exceeded: "Ez a promóciós kód elérte a felhasználási korlátját, és már nem érhető el.",
                },
            },
            dish: {
                add: 'Kosárba',
                edit: 'Elem frissítése',
                notes: 'Különleges utasítások...',
                ingredients: {
                    title: 'Hozzávalók',
                    uncheck_remove: 'Törölje a pipát az eltávolításhoz',
                },
                ingredients_title: 'Hozzávalók',
                combo: {
                    choose_dish: 'Válasszon egy elemet',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Válasszon egyet (kötelező)',
                        select_one_optional: 'Válasszon egyet (opcionális)',
                        select_between: 'Válasszon a {{min}} - {{max}} között (kötelező)',
                        select_at_least: 'Válasszon legalább {{qty}} (kötelező)',
                        select_up_to: 'Válasszon legfeljebb {{qty}} (opcionális)',
                        select_multiple_optional: 'Több kiválasztása (opcionális)',
                        select_multiple: 'Több kiválasztása (kötelező)',
                        free_amount: 'Első {{qty}} Ingyenes / {{selected}} Kiválasztva',
                    },
                    points: {
                        none_consumed: 'Legfeljebb {{maxFree}} opciót választhat ingyenesen',
                        less_than_total_points: 'Több lehetőséget választhat ingyenesen',
                        greather_than_total_points: 'Felár ellenében több lehetőséget is választhat',
                    },
                },
                error: 'Kérjük, javítsa ki a pirossal jelölt opciókat',
                added_to_cart: 'Tétel a kosárba',
            },
            map: {
                zone_fee: 'Szállítási díj',
                view_in_google: 'Megtekintés a Google Térképen',
            },
            portal_go_back: {
                title: 'Vissza az étteremkeresőhöz?',
                description: 'A kosárban lévő termékek elvesznek',
                cancel: 'Mégse',
                proceed: 'Menj vissza',
            },
            order: {
                config: {
                    services: {
                        title: 'Válasszon egy szolgáltatást',
                        table_booking: 'Könyv táblázat',
                    },
                    address_custom: {
                        input_placeholder: 'Írja be a címét',
                    },
                    address: {
                        input_placeholder: 'Keresse meg szállítási címét',
                        extras_placeholder: 'Egységszám, épületnév, szállítási utasítás stb...',
                        search_placeholder: 'Keresse meg címét',
                        search_input_placeholder: 'Írja be a kereséshez',
                        no_address_found: 'Nem található cím. Próbáljon 5 karakternél többet beírni',
                        not_found: 'A szállítási cím nem található, vagy nem érvényes, próbálkozzon újra',
                        not_delivering: 'Jelenleg nem szállítunk erre a címre',
                        not_in_range: 'Az Ön címe nem esik üzletünk hatókörébe',
                        not_in_zone: 'Az Ön címe nem egy aktív kézbesítési zónán belül van',
                        no_number: 'A címnek tartalmaznia kell egy utcaszámot',
                        location_permission: 'Engedélyezi ennek a webhelynek, hogy hozzáférjen jelenlegi tartózkodási helyéhez?',
                        location_permission_warning: "Nem fér hozzá a jelenlegi helyéhez. Kérjük, engedélyezze a helyszolgáltatást a készülékén és a böngészőjén. Itt van néhány referencia:",
                        pick_location: 'Válassza ki a helyét',
                        pick_location_help_text: 'Húzza a jelölőt a hely kiválasztásához a térképen.',
                        use_current_location: 'Jelenlegi hely használata',
                        locate_on_map: 'Keresse meg a térképen',
                    },
                    datetime: {
                        title: 'Mikor szeretné megrendelni',
                        due_now: 'Jelenleg',
                        due_later: 'Később',
                        service_not_available: 'Sajnáljuk, jelenleg nem fogadunk rendeléseket {{service}}',
                        currently_closed: '{{service}} jelenleg zárva, de később is rendelhet',
                        due_unavailable: 'Nem elérhető',
                        due_closed: 'Zárt',
                        select_date: 'Válassza a Dátum lehetőséget',
                        select_time: 'Válassza az Idő lehetőséget',
                        select_order_date: 'Válassza ki a rendelés dátumát',
                        select_order_time: 'Válassza ki a rendelési időt',
                        select_order_date_time: 'Válassza ki a rendelés dátumát/időpontját',
                        select_booking_date: 'Válassza ki a foglalás dátumát',
                        select_booking_time: 'Válassza ki foglalási idejét',
                        no_times_available: 'Nem választható időpontok közül választhat',
                        date_today: '(Ma)',
                        date_closed: '(Zárt)',
                        date_bookings_paused: '(Foglalások szünetelnek)',
                        time_slot_closed: 'Zárt',
                    },
                    number_of_people: {
                        placeholder: 'Emberek száma',
                    },
                    table: {
                        select: 'Válassza a Táblázatot',
                        select_popup_title: 'Válassza ki az asztalát',
                        password: 'Táblázat jelszó',
                        password_warning: 'A folytatáshoz adja meg a táblázat jelszavát',
                    },
                    warning: {
                        closed: 'Sajnáljuk, jelenleg zárva vagyunk / rendeléseket nem fogadunk',
                        not_available: 'Sajnáljuk, jelenleg nem fogadunk rendelést',
                    },
                    eta: {
                        delivery: `A becsült szállítási idő körülbelül {{minutesToCustomer}} perc`,
                        pickup: `A rendelés körülbelül {{minutesToCustomer}} percen belül elkészül`,
                    },
                    start_button: 'Megrendelés indítása',
                },
                history: {
                    invalid: 'Nem jogosult a megrendelés újrarendelésére, mert néhány rendelt tétel módosítva lett, vagy nem érhető el',
                },
                reorder: {
                    title: 'Gyors újrarendelés',
                    description: 'Könnyen megrendelheti a korábbi rendeléseiből származó termékeket',
                },
            },
            receipt: {
                errors: {
                    not_found: 'A rendelés nem található, frissítse az oldalt, és próbálja újra',
                    booking_not_found: 'A foglalás nem létezik. Lehet, hogy törölték',
                    generic: 'Hiba történt, frissítse az oldalt, vagy lépjen kapcsolatba velünk',
                },
                connection: {
                    connected: 'Valós idejű frissítések',
                    connecting: 'Valós idejű frissítések kapcsolódnak',
                    disconnected: 'A valós idejű frissítések kapcsolata megszakadt',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Figyelmeztetés',
                    title: 'Kijelentkezés',
                    body: 'A kijelentkezéssel eltávolítja a kosárba helyezett termékeket',
                    cancel: 'Mégse',
                    proceed: 'Folytassa',
                },
                order_restart: {
                    warning: 'Figyelmeztetés',
                    title: 'Megrendelés részleteinek módosítása',
                    body: 'A megrendelés adatainak módosítása eltávolítja a kosárban lévő tételeket, mivel előfordulhat, hogy bizonyos termékek elérhetetlenné válnak',
                    cancel: 'Mégse',
                    proceed: 'Folytassa',
                },
                order_expired: {
                    subtitle: 'Fontos',
                    title: 'A rendelés azonnali esedékességre módosult',
                    description: 'A rendelés idejét választotta. A rendelés azonnali / ASAP-re módosult',
                    button: 'Rendben',
                },
                order_expiring: {
                    subtitle: 'Fontos',
                    title: 'A megrendelés határideje hamarosan lejár',
                    description: 'Rendelését {{time, timeFromTimestamp}} előtt kell leadnia, különben már nem lesz érvényes',
                    button: 'Rendben',
                },
                location_permission: {
                    cancel: 'Mégse',
                    proceed: 'Folytassa',
                },
            },
            card_payment_authentication: {
                title: 'Fizetési hitelesítés',
                note: 'Kérjük, tartsa nyitva ezt az ablakot, amíg be nem fejezi a hitelesítési folyamatot a banktól.',
            },
            maps: {
                cancel: 'Mégse',
                use_location: 'Használja a Location lehetőséget',
            },
            app_refresh: {
                refresh: 'Frissítés',
                title: 'Áruház frissítése',
                description: 'A boltunk frissítést észlelt. Kérjük, frissítse a böngészőjét a legújabb verzió eléréséhez. A frissítés után előfordulhat, hogy újra kell nyitnia a kosarat a fizetési folyamat folytatásához.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Vendég',
                login: 'Bejelentkezés',
                login_signup: 'Bejelentkezés / Regisztráció',
                logout: 'Kijelentkezés',
            },
            menus: {
                info: {
                    no_menus: 'Jelenleg nincsenek elérhető menük',
                    restrictions: 'Menü korlátozások',
                    not_available: 'A menü nem elérhető',
                    unavailable: {
                        times: "A menü nem elérhető, a rendelési követelmények nem egyeznek a következővel",
                        services: "A menü nem elérhető, a rendelési követelmények nem egyeznek a következővel",
                        hours: 'Az étlap nem elérhető, a rendelési idő nem ezen a menün belül érhető el',
                        pre_order: "A menü nem elérhető, a rendelési követelmények nem egyeznek a következővel",
                        age: 'A menü nem elérhető, be kell jelentkeznie egy korhatáros fiókkal, hogy rendeljen ebből a menüből',
                    },
                    services: {
                        title: 'Rendelési követelmények',
                        pickup: 'Hangszedők',
                        delivery: 'Szállítások',
                        dine_in: 'Helyben fogyasztás',
                    },
                    times: {
                        now: 'Nincs előrendelés',
                        later: 'Csak előrendelésre',
                    },
                    hours: {
                        title: 'Rendelkezésre álló órák',
                    },
                    preorder: {
                        title: 'Előrendelési követelmények',
                        days_in_advance: 'Rendelni kell {{days}} nappal előre',
                        cutoff_time: 'Az utolsó nap végi időpontja: {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Korhatáros',
                        approved: 'Fiókja igazolva van, és ebből a menüből rendelhet',
                        rejected: 'A megrendeléshez életkor igazolás szükséges. Hozzon létre egy fiókot, és töltse fel azonosítóját',
                    },
                },
                search: {
                    title: 'Fedezze fel a menüelemeket',
                    no_result: 'Semmi sem jött vissza. Kipróbál egy másik keresési kifejezést?',
                    placeholder: 'Mit keres?',
                },
            },
            category: {
                restrictions: 'Kategória korlátozások',
                not_available: 'A kategória nem elérhető',
                unavailable: {
                    services: "A kategória nem elérhető, a rendelési követelmények nem egyeznek a következővel",
                    hours: "A kategória nem elérhető, a rendelési idő nem ezen a kategórián belül érhető el",
                },
            },
            info: {
                location: {
                    title: 'Elhelyezkedés',
                    view_map: 'Térkép megtekintése',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Nyitva tartás',
                    title_special: 'Különleges nyitva tartás',
                },
                services: {
                    title: 'Szolgáltatások',
                    notes: 'Megjegyzések',
                    delivery: {
                        ranges: 'Szállítási tartományok',
                        zones: 'Szállítási zónák',
                        view_zones: 'Zónák megtekintése a térképen',
                        fee: 'Szállítási díj',
                        fee_short: 'Díj',
                        fee_varies: 'Változó, a kosárban látható',
                        min_order: 'Minimális rendelés',
                        min_order_short: 'Min. rend.',
                        no_min_order: 'Nincs minimális rendelés',
                        free_amount: 'Ingyenes szállítási összeg',
                    },
                },
            },
            contact: {
                title: 'Lépjen kapcsolatba velünk',
                name: 'Név',
                email: 'E-mail-cím',
                phone: 'Telefonszám',
                message: 'Írja be az üzenetet...',
                send: 'Üzenet küldése',
                success: 'Üzenetét sikeresen elküldtük',
                error: 'Hiba történt. Próbálkozzon újra, vagy egy későbbi időpontban',
            },
            footer: {
                powered_by: 'Üzemeltető',
                terms_and_conditions: 'Általános Szerződési Feltételek',
                privacy: 'Adatvédelmi szabályzat',
                cookie: 'Cookie-szabályzat',
            },
        },
        pages: {
            payment_completed: {
                title: 'Befizetését feldolgoztuk. Köszönjük megrendelését!',
                subtitle: 'A megrendelés adatait elküldtük az Ön e-mail címére.',
                back_to_menu: 'Vissza a menühöz',
                close_tab: 'Zárja be ezt a lapot',
            },
            payment_failed: {
                title: 'Sajnos hiba történt a fizetés feldolgozása során.',
                subtitle: '',
                back_to_menu: 'Vissza a menühöz',
                close_tab: 'Zárja be ezt a lapot',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Foglalási nyugta',
            details: {
                datetime: 'Foglalás:',
                number_of_people: 'Emberek száma',
                placed: 'Elhelyezve',
                updated: 'Utoljára frissítve',
                notes: 'Megjegyzések',
                name: 'Név',
                email: 'E-mail-cím',
                phone: 'Telefon',
                store_address: 'Bolt címe',
            },
            status_update: {
                title: 'Foglalás {{number}} Frissítve',
                body: 'Foglalásának állapota a következőre módosult: {{status}}',
            },
            email_common: {
                name: 'Név: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Személyek száma: {{number}}',
                date: 'Dátum: {{date}}',
                time: 'Idő: {{time}}',
                location: 'Üzlet helye: {{name}}',
                notes: 'Megjegyzések: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Új asztalfoglalás {{number}} {{name}}',
                powered_by: 'Üzemeltető: {{name}}',
                overview: 'Új asztalfoglalási kérelem',
                title: 'Új foglalás {{name}}',
                subtitle: 'Foglalási szám {{number}}',
                description_confirmed: 'A foglalás automatikusan megerősítve lett. A foglalást az adminisztrációs irányítópulton keresztül törölheti, és a kliensét e-mailben értesítheti',
                description_unconfirmed: 'Kérjük, erősítse meg vagy törölje a foglalást az adminisztrációs irányítópulton keresztül',
                url_pre_text: 'Megtekintés és frissítés itt:',
            },
            email_new_booking_customer: {
                subject: 'Asztalfoglalási kérés',
                powered_by: 'Üzemeltető: {{name}}',
                overview: 'Új asztalfoglalási kérelem',
                title: 'Köszönjük foglalását',
                subtitle: 'Foglalási szám {{number}}',
                description: '<b>A foglalás megerősítve vagy elutasítva lesz.</b><br>Kérjük, lépjen kapcsolatba velünk a foglalás bármely módosításához. A foglalás részletei a következők:',
                url_pre_text: 'Megtekintheti valós idejű foglalási nyugtáját a következő címen:',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Asztalfoglalás megerősítve',
                subject_unconfirmed: 'Asztalfoglalás törölve',
                powered_by: 'Üzemeltető: {{name}}',
                overview: 'Asztalfoglalási kérés',
                title_confirmed: 'Foglalás megerősítve',
                title_unconfirmed: 'Foglalás törölve',
                subtitle: 'Foglalási szám {{number}}',
                description_confirmed: 'Megköszönjük, hogy meglátogatjuk. Kérjük, lépjen kapcsolatba velünk a foglalás bármely módosításához',
                description_unconfirmed: 'Sajnáljuk, hogy tájékoztatjuk, hogy a foglalási kérése nem fogadható el. Megbocsájtunk bármilyen kellemetlenséget okozva. Kérjük, lépjen kapcsolatba velünk, ha bármilyen kérdése van',
                url_pre_text: 'Megtekintheti valós idejű foglalási nyugtáját a következő címen:',
            },
            email_status_update_customer: {
                subject: 'Foglalás #{{number}} – {{subjectLabel}}',
                body: 'A(z) {{store}} étteremben lévő #{{number}} foglalása most {{status}}.',
            },
            errors: {},
            status_warning: 'Frissítse a foglalás állapotát az adminisztrációs irányítópulton a foglalások oldalon',
        },
    },
    email_delayed_order: {
        subject: 'Rendelés #{{number}} – {{subjectLabel}}',
        header: 'Frissített elkészülési idő',
        title: 'Frissített elkészülési idő',
        order_number: 'Rendelési szám: {{number}}',
        description: 'A rendelése most {{time}} időpontban készül el.',
        order_time_updated_to: 'A rendelése időpontja frissült.',
        powered_by: 'Üzemeltető: {{name}}',
        button_text: 'Pályarend',
        subject_label: 'Frissített elkészülési idő',
        subject_label_delivery: 'Frissített szállítási idő',
        body_ready: 'A rendelése most {{time}} időpontban készül el.',
        body_delivery: 'A rendelését most {{time}} időpontban szállítjuk.',
    },
    order: {
        receipt: {
            est_ready_time: 'Becs. Készenléti idő',
            est_driver_pickup_time: 'Becs. A sofőr felvételi ideje',
            est_delivery_time: 'Becs. Szállítási idő',
            tab_details: 'Részletek',
            tab_dishes: 'Elemek',
            future_order: 'Jövő rendje',
            reprint: 'ÚJRANYOMTATÁS',
            details: {
                order_no: 'Rendelési szám',
                status: 'Állapot',
                placed: 'Elhelyezve',
                due: 'Esedékes',
                due_asap: 'Azonnali / ASAP',
                last_updated: 'Utoljára frissítve',
                total: 'Teljes',
                type: 'Írja be',
                origin: 'Származás',
                table: 'Táblázat',
                number_of_people: 'Emberek száma',
                payment_method: 'Fizetési mód',
                payment_status: 'Fizetési állapot',
                payment_currency: 'Fizetési pénznem',
                notes: 'Megjegyzések',
                name: 'Név',
                email: 'E-mail-cím',
                phone: 'Telefon',
                distance: 'Távolság',
                driving_time: 'Vezetési idő',
                delivery_zone: 'Zóna',
                delivery_address: 'Szállítási cím',
                delivery_provider: 'Szállítási Szolgáltató',
                delivery_tracking: 'Szállítás nyomon követése',
                delivery_return_tracking: 'Visszatérés pálya',
                delivery_tracking_link: 'Pályarend',
                tookan_status: 'Tookan állapota',
                tookan_status_failed_book: 'Nem sikerült lefoglalni a kézbesítést',
                tookan_status_failed_update: 'Nem sikerült frissíteni a foglalást',
                tookan_status_success: 'Lefoglalva szállításra',
                store_address: 'Bolt címe',
                destination: 'Rendeltetési hely',
                estimated_arrival_time: 'Becsült érkezési idő',
                delivery_status: 'Állapot',
                delivery_track_your_order: 'Kövesse nyomon megrendelését',
                delivery_text: 'Szállítás',
                arrival_date: 'Érkezés dátuma',
            },
            dishes: {
                headings: {
                    quantity: 'Menny',
                    item: 'Tétel',
                    price: 'Ár',
                },
                notes: 'Megjegyzések',
                remove_ingredients: 'Távolítsa el az összetevőket',
            },
            status_update: {
                title: 'Megrendelés {{number}} frissítve',
                body: 'Megrendelésének állapota a következőre módosult: {{status}}',
            },
            wait_time_update: {
                title: 'Megrendelés {{number}} frissítve',
                body: 'Megrendelésének határideje frissült',
            },
            delivery_update: {
                title: 'Megrendelés {{number}} frissítve',
                body: 'Rendelését kézbesítésre lefoglaltuk. Lásd a valós idejű nyomkövető linket',
            },
            payment_status_update: {
                title: 'Megrendelés {{number}} frissítve',
                body: 'Megrendelésének fizetési állapota frissült.',
            },
            email_new_order_restaurant: {
                subject: 'Új rendelés ({{number}}) - {{name}}',
                powered_by: 'Üzemeltető: {{name}}',
                overview: 'Értesítés az új rendelésről',
                title: 'Új rendelés leadva: {{name}}',
                subtitle: 'Rendelési szám {{number}}',
                description: 'Tekintse meg a részleteket és a frissítéseket a rendszergazdai irányítópulton',
                button_text: 'Pályarend',
                track_delivery_button_text: 'Szállítás követése',
            },
            email_new_order_customer: {
                subject: 'Megrendelés nyugta ({{number}})',
                powered_by: 'Üzemeltető: {{name}}',
                overview: 'Értesítés az új rendelésről',
                title: 'Új rendelés leadva: {{name}}',
                subtitle: 'Rendelési szám {{number}}',
                description: 'Tekintse meg a részleteket és a frissítéseket a valós idejű online nyugtán keresztül',
                button_text: 'Pályarend',
                track_delivery_button_text: 'Szállítás követése',
            },
            email_order_completed_by_customer: {
                subject: 'Megrendelés ({{number}}) az Ügyfél által teljesítve',
                powered_by: 'Üzemeltető: {{name}}',
                overview: 'Megrendelés kész értesítés',
                title: 'Megrendelés teljesítve: {{name}}',
                subtitle: 'Rendelési szám {{number}}',
                description: 'Tekintse meg rendelésének részleteit és frissítéseit az irányítópulton vagy a nyugta segítségével:',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. árban',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Szállítási díj',
            delivery_fee_offset: 'Szállítási díj kedvezmény',
            delivery_fee_total: 'Szállítási díj összesen',
            promo: 'Kedvezmény: {{name}} ({{value, currency}} + {{percent}}% kedvezmény)',
            promo_percent: 'Kedvezmény: {{name}} ({{percent}}%)',
            promo_fixed: 'Kedvezmény: {{name}}',
            promo_none: 'Kedvezmény: {{name}}',
            cart: 'Kosár',
            tip: 'Rendelési tipp',
            total: 'Teljes',
        },
        status: {
            unconfirmed: 'Meg nem erősített',
            awaiting_payment: 'Fizetésre vár',
            confirmed: 'Megerősített',
            ready: 'Kész',
            on_route: 'Útvonalon',
            complete: 'Teljes',
            cancelled: 'Törölve',
            seated: 'Leültetve',
        },
        searching: {
            lalamove_search_placeholder: 'Rendelés keresése Lalamove szállítási azonosítója alapján',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Nem elérhető',
                },
            },
            dish: {
                no_stock: 'Elfogyott',
                not_available: 'Nem elérhető',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'E-mail megerősítő kód',
            register_confirmation_code_email: 'Az e-mail megerősítő kódja: {{confirmation_code}} (24 órán belül lejár)',
            register_confirmation_code_email_onbehalf: 'Az e-mail megerősítő kódja: {{confirmation_code}} (24 órán belül lejár). Ez az e-mail cím, {{email}}.',
        },
    },
};
//# sourceMappingURL=hu.js.map